<template>
  <div class="need-attention themic">
    <div class="--header">
      <Select dbref="MST.SelBalai" :value.sync="balaiId" width="100%" />
    </div>
    <div class="--body">
      <List
        style="font-size:small"
        ref="list"
        dbref="AST.SelKalendarPembayaran"
        groupBy="Header"
        :dbparams="dbparams"
        height="calc(100vh - 160px)"
      >
        <template v-slot="{ row }">
          <div class="dash-header" style="font-weight:bold" v-if="row.Header">
            {{ row.Header }}
          </div>
          <div
            style="display:flex; padding:10px 0px 10px 10px; background:white; border-bottom: 1px solid silver;"
          >
            <div style="flex:3">
              <a style="font-weight:bold; display:block" @click="Detail(row)">
                {{ row.NamaPerusahaan }}
              </a>
              <div style="font-size:x-small">{{ row.NamaPotensi }}</div>
              <div style="font-size:x-small">{{ row.NamaAsset }}</div>
            </div>
            <div style="flex:2; text-align:right">
              {{ row.Harga | format }}
              <br />
              {{ row.MulaiSewa | format }}
            </div>
            <div style="flex:1; text-align:center">
              <MenuButton
                v-if="row.Action"
                :items="[
                  { text: 'Bayar' },
                  {
                    text: `Kirim ${row.Action}`,
                    color: 'red',
                    icon: 'mdi-alert',
                  },
                ]"
                @click="SendSP($event, row)"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :outlined="row.Peringatan == row.Action"
                    color="error"
                    small
                    style="position:relative; top:5px;"
                    v-on="on"
                  >
                    {{ row.Action }}
                  </v-btn>
                </template>
              </MenuButton>
              <v-btn
                color="primary"
                small
                style="position:relative; top:5px;"
                v-else
                @click="Bayar(row)"
              >
                BYR
              </v-btn>
            </div>
          </div>
        </template>
      </List>
    </div>
    <add-penerimaan
      :data.sync="potensi"
      @reload="rebindPotensi++"
    ></add-penerimaan>
    <upd-penerimaan :forms="potensi" @reload="reload"></upd-penerimaan>
  </div>
</template>
<script>
import AddPenerimaan from '../Asset/Penerimaan/AddPenerimaan.vue'
import UpdPenerimaan from '../Asset/Penerimaan/UpdPenerimaan.vue'
export default {
  components: { AddPenerimaan, UpdPenerimaan },
  data: () => ({
    potensi: { showUpd: false },
    items: [],
    lastHeader: '',
    balaiId: localStorage.getItem('balaiId'),
  }),
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    dbparams() {
      return { BalaiId: this.balaiId }
    },
  },
  methods: {
    SendSP(menu, row) {
      if (menu.text == 'Bayar') {
        this.Bayar(row)
      } else {
        if (row.Peringatan === row.Action) return
        if (!confirm(`Kirim ${row.Action}`)) return
        this.$api.call('AST_SavPeringatan', {
          PenerimaanId: row.PenerimaanId,
          Peringatan: row.Action,
        })
        this.$refs.list.rebind()

        this.$api.download(
          `/api/asset/template/teguran?PotensiId=${row.PotensiId}`
        )
      }
    },
    Detail(row) {
      this.potensi = {
        ...row,
        show: true,
      }
    },
    Bayar(row) {
      this.potensi = {
        ...row,
        showUpd: true,
      }
    },
    reload() {
      setTimeout(() => {
        this.$refs.list.rebind()
      }, 500)
    },
  },
}
</script>
<style lang="scss">
.dash-header {
  background: #f3f3f3;
  display: flex;
  padding: 5px;
  border-bottom: 1px solid silver;
  position: relative;
  padding-right: 40px;
  font-size: small;
}
</style>
